var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection role=\"logos\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12\"\u003E\u003Cdiv class=\"logos-container\"\u003E\u003Cdiv class=\"logo-talbots\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"logo-bluetooth-sig\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"logo-amd\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"logo-mozilla\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"logo-ch-robinson\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2e/view/partials/customers-logos.pug
// module id = 1133
// module chunks = 0